import { reactive } from "vue";

export const tenantStore = reactive({
  uuid: "",
  name: "",
  languages: [],
});
